import { createAction, props } from '@ngrx/store';

export const init = createAction('[Start] Startup Actions', props<{ token: string; businessId: string; businessType }>());
export const cancelInit = createAction('[Start] Cancel Startup Actions');
export const initSuccess = createAction('[Start] Startup success');
export const loading = createAction('[Start] Loading', props<{ loading: boolean }>());
